import { CRUDAction, FeatureKey } from 'common/constants/permission'
import { useSpeciesName } from 'modules/pond/api/selector'
import { usePermitToActionFeature } from 'modules/user/api/selector'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import AddIcon from '@mui/icons-material/Add'
import { Box, Button, Card, Typography } from '@mui/material'

interface ShrimpSalesRecordCardProps {
  onClick: () => void
}

const ShrimpSalesRecordCard: FC<ShrimpSalesRecordCardProps> = ({ children, onClick }) => {
  const { t } = useTranslation('shrimpSales')
  const speciesName = useSpeciesName()
  const showRecordBtn = usePermitToActionFeature([CRUDAction.Create], FeatureKey.Sales)

  return (
    <Card sx={{ p: 2, height: '100%' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 1 }}>
        <Typography variant="h5">{`${t('harvest', { speciesName })}`}</Typography>
      </Box>
      {children}
    </Card>
  )
}

export default ShrimpSalesRecordCard
